import React from 'react'
import { NavLink } from 'react-router-dom'
import "./mehanism.css"
import mehanism1 from "../../images/mehanism1.png"
import mehanism2 from "../../images/mehanism2.png"
import mehanism3 from "../../images/mehanism3.png"
import mobileMehanism1 from "../../images/mobileMehanism1.png"
import mobileMehanism2 from "../../images/mobileMehanism2.png"
import mobileMehanism3 from "../../images/mobileMehanism3.png"

const Mehanism = () => {
  return (
    <div className="content mehanismPage">
      <div className="header">
        Наградна игра траје <br className="mobileVersion" /> од 06.04. до 17. 05. 2026. године.
      </div>

      <div className="textInfo">
        Унеси код испод затварача са повратне боце 0,5л, неповратне боце 0,33л или лименке 0,5л
        на
        <NavLink to="/unesi-kod"><span> www.zajecarskoigra.rs </span></NavLink>
        или пошаљи код на <span>6600</span>.
      </div>

      {/*HERE IS DESKTOP VERSION OF IMAGES AND  TEXT */}
      <div className="imageHolder desktopVersion">
        <img src={mehanism1} />
        <img src={mehanism2} />
        <img src={mehanism3} />
      </div>

      <div className="titleImageHolder desktopVersion">
        <div className="item">
          <div className="number">1.</div>
          <div className="text">Купи повратну боцу 0,5л, неповратну боцу 0,33л или лименку 0,5л Зајечарско пива</div>
        </div>

        <div className="item">
          <div className="number">2.</div>
          <div className="text">Пронађи КОД испод затварача флаше или на врху лименке</div>
        </div>

        <div className="item">
          <div className="number">3.</div>
          <div className="text">Пошаљи код СМС поруком на број 6600 ИЛИ унеси код на web сајту www.zajecarskoigra.rs </div>
        </div>
      </div>

      {/*HERE IS MOBILE VERSION OF IMAGES AND  TEXT */}
      <div className="imageHolder mobileVersion">

        <div className="titleImageHolder">
          <div className="item">
            <div className="number">1.</div>
            <div className="text">Купи повратну боцу 0,5л, неповратну боцу 0,33л или лименку 0,5л Зајечарско пива.</div>
          </div>
        </div>

        <img src={mobileMehanism1} className="packshotResize" />

        <div className="titleImageHolder">
          <div className="item">
            <div className="number">2.</div>
            <div className="text">Пронађи КОД испод затварача флаше или на врху лименке.</div>
          </div>
        </div>

        <img src={mobileMehanism2} className="packshotResize2" />

        <div className="mobileCodeText">Ако је КОД написан у 2 реда, <br />
          потребно је да буде унет/послат у једном реду, спојено.</div>


        <div className="titleImageHolder">
          <div className="item">
            <div className="number">3.</div>
            <div className="text">Пошаљи код СМС поруком на број 6600
              ИЛИ унеси код на web сајту
              www.zajecarskoigra.rs</div>
          </div>
        </div>

        <img src={mobileMehanism3} />


      </div>


      <div className="lineBreak"></div>

      <div className="outroText">
        Ограничења: У току трајања Наградне игре, један учесник може освојити
        највише један ВАУЧЕР У ВРЕДНОСТИ ОД 2000 ЕВРА ЗА ОПРЕМАЊЕ КУХИЊЕ и највише један АУТОМОБИЛ ШКОДА ОКТАВИЈА.
      </div>

      <div className="lineBreak"></div>

      <div className="outroHeader">
        Бирај одговорно <span>- <br className="mobileVersion" /> КАДА ПИЈЕШ НЕМОЈ ВОЗИТИ.</span>
      </div>
    </div>
  )
}

export default Mehanism